<template>
    <div>
		<Iframe v-bind:sermon="sermon"/>
        <Sermons v-bind:sermons="sermons" v-on:selected="updateSelected"/>
        <Verse />
        <Footer />
    </div>
</template>
<script>
import Iframe from './Iframe.vue'
import Sermons from './Sermons.vue'
import Verse from '../index/Verse.vue'
import Footer from "../../components/Footer.vue";

import ENV from '../../constants/Environment.js';
import LiveStreamService from '../../services/LiveStream.js';

export default {
    name: "Index",
    data: function() {
        return {   
            facebook: ENV.FACEBOOK_LINK, 
            facebookLive: ENV.FACEBOOK_LIVE_LINK, 
            sermon: {
                VideoID: ""
            },
            sermons: []
        }
    },
    components: { Iframe, Sermons, Verse, Footer },
    created: function() {
        var self = this;

        const videoIdParam = this.$route.params.videoid;
        if (videoIdParam) {
            self.sermon.VideoID = videoIdParam;
        }

        LiveStreamService.getVideo().then(function(response) {
            self.sermon = response[0];
            self.sermons = response;
        })
    },
    methods: {
        updateSelected: function(pSelected) {
            this.sermon = pSelected;
        }
    }
};
</script>
